import { Injectable } from '@angular/core';
import { BehaviorSubject, firstValueFrom, Observable, observable } from 'rxjs';
import { Subject } from 'rxjs';
import { HttpService } from '../http/http.service';
import { EmployeeContract } from '../../interface';
@Injectable({
  providedIn: 'root'
})
export class EmployeeContractService {
  constructor(private http: HttpService) { }

  public getAll(): Promise<EmployeeContract[]> {
    return firstValueFrom(this.http.get('/Contracts'));
  }
    public get(id:number): Promise<EmployeeContract> {
    return firstValueFrom(this.http.get('/Contracts/'+id));
  }

  public create(data): Promise<EmployeeContract> {
    return firstValueFrom(this.http.post('/Contracts', data));
  }
  
  public update(id:number,data): Promise<EmployeeContract> {
    return firstValueFrom(this.http.patch('/Contracts/',id, data));
  }
  
  public delete(id:number): Promise<EmployeeContract> {
    return firstValueFrom(this.http.delete('/Contracts/',id));
  }

}
